import { render } from "./userProfileView.vue?vue&type=template&id=62c97114"
import script from "./userProfileView.vue?vue&type=script&lang=js"
export * from "./userProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__